import React from 'react';
import { Zap, RefreshCw, TrendingUp } from 'lucide-react';
import styles from './LandingDataFlow.module.scss';

const steps = [
  {
    icon: RefreshCw,
    title: 'Register your account',
    description:
      'Sign up in seconds to start building your unified business workspace.',
  },
  {
    icon: Zap,
    title: 'Upload your records',
    description:
      'Upload invoices, receipts, and expenses. Our system handles the bookkeeping for you.',
  },
  {
    icon: TrendingUp,
    title: 'Generate PFRS reports',
    description:
      'Instantly generate balance sheets, income statements, and more—all PFRS-compliant.',
  },
];

function LandingDataFlow() {
  return (
    <section
      id="how-it-works"
      className={styles.section}
      aria-labelledby="flow-heading"
    >
      <div className={styles.inner}>
        <div className={styles.headerRow}>
          <div>
            <p className={styles.sectionTag}>How it works</p>
            <h2 id="flow-heading" className={styles.title}>
              Three simple steps...
            </h2>
          </div>
        </div>

        <ol className={styles.cardsGrid} aria-label="How to get started steps">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <li key={step.title} className={styles.card}>
                <div className={styles.cardTopRow}>
                  <span
                    className={styles.cardNumber}
                  >{`Step ${index + 1}`}</span>
                  <div className={styles.stepIconWrap} aria-hidden="true">
                    <Icon size={18} />
                  </div>
                </div>
                <h3 className={styles.stepTitle}>{step.title}</h3>
                <p className={styles.stepDescription}>{step.description}</p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}

export default LandingDataFlow;
